// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class RetrievePayloadRequest {
    static getAttributeTypeMap() {
        return RetrievePayloadRequest.attributeTypeMap;
    }
}
RetrievePayloadRequest.discriminator = undefined;
RetrievePayloadRequest.additionalProperties = false;
RetrievePayloadRequest.attributeTypeMap = [
    {
        "name": "systemCode",
        "baseName": "systemCode",
        "type": "string"
    },
    {
        "name": "systemId",
        "baseName": "systemId",
        "type": "string"
    },
    {
        "name": "purposeCode",
        "baseName": "purposeCode",
        "type": "string"
    },
    {
        "name": "purposeId",
        "baseName": "purposeId",
        "type": "string"
    },
];
//# sourceMappingURL=retrievePayloadRequest.js.map